import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/global-factor-rules/edit/$id/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      (!!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.GLOBAL_FACTOR_RULES }) ||
        !!context.userPermissions.hasAllowedPermission({
          path: PAGE_PATHS.GLOBAL_FACTOR_RULES,
          permission: Permission.UPDATE,
        })) &&
      !!context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
